import { createContext, useContext } from "react";
import type { Member } from "@/types/Member";

export interface MemberContextType {
  member: Member | null;
  todaysBookings: number;
  refreshMember: () => Promise<void>;
  /**
   * Re-fetch the member from the server (GET /api/me) and reflect any role/permission change
   * live, without a logout/login. Merges over the cached tpruser (preserving login-only gate
   * fields), persists, and updates state only when something actually changed. On failure it
   * keeps the current member — never blanks it.
   */
  syncMemberFromServer: () => Promise<void>;
}

export const MemberContext = createContext<MemberContextType | undefined>(undefined);

export const useMember = () => {
  const context = useContext(MemberContext);
  if (!context) {
    throw new Error("useMember must be used within a MemberProvider");
  }
  return context;
};
